<template>
  <div class="app d-flex flex-column">
    <div class="app__main-nav">
      <RouterView name="header" />
    </div>
    <div class="container">
      <RouterView name="navigation" />
    </div>
    <div class="app__container flex-grow-1" :class="$route.name" id="app__container">
      <RouterView name="default" />
    </div>
    <div class="overlay-content" :class="{'active':  $route.name == 'about.page' }" id="app__overlay">
      <RouterView name="overlay_content" />
    </div>
    <RouterView name="footer" class="app__footer" />
  </div>
</template>

<script>
  import i18n from '@/mixins/i18n'

  export default {
    name: 'App',
    mixins: [i18n],
    props: {
      locale: {
        type: String,
        default: null
      }
    },
    beforeMount () {
      this.setLocale(this.$route.params.locale)
      window.scrollTo(0, 0)
    },
    beforeRouteUpdate (to, from, next) {
      this.setLocale(from.params.locale)
      if(to.name != 'list') {
        window.scrollTo(0, 0)
        if(document.querySelector('.players-region-modal') && document.querySelector('.players-region-modal').classList.contains('open-nav')) {
          document.querySelector('.players-region-modal').classList.remove('open-nav')
          document.querySelector('body').classList.remove('open-nav')
        }          
      }        
      next()
    }
  }
</script>

<style lang="scss">
  .app {
    min-height: 100vh;
    margin: 0;
    padding: 0;

    &--has-content-overlays {
      overflow: hidden;
    }

    &__disclaimer-note {
      position: sticky;
      bottom: 0;
      padding: 15px 0;
      z-index: 999999;
      background: var(--app-color-red);

      .container {
        color: #fff;
        text-align: center;
      }
    }

    &__container {
      &.client\.embed {
        overflow: hidden;
      }
    }

    &__footer {
      position: relative;
      z-index: 900;
    }
  }
</style>
